import type { BreadcrumbLink } from '#/components/Breadcrumbs/Breadcrumbs';
import type { CmsApiCategory } from '#/modules/cms/api/types/CmsApiCategory';
import type { CmsApiSubsite } from '#/modules/cms/api/types/CmsApiSubsite';

// Pass the post's own subsite, not the one from location state. Post search
// puts the parent subsite there, which would mix subsites in the trail and
// cause an SSR/client mismatch
type Args = {
  subsite: Pick<CmsApiSubsite, 'publicName' | 'homePage'>;
  categories: CmsApiCategory[];
};

export function getCmsPostPathwayLinks({
  subsite,
  categories,
}: Args): BreadcrumbLink[] | undefined {
  if (!subsite.homePage) return undefined;

  const homePageUrl = subsite.homePage.url;
  const subsiteLink: BreadcrumbLink = {
    title: subsite.publicName,
    to: `/${homePageUrl}`,
    qaId: 'breadcrumbs-mobile-subsite-link',
  };

  const category = categories
    .filter(({ parentId }) => parentId === null)
    .reduce<CmsApiCategory | undefined>(
      (lowest, candidate) =>
        lowest && lowest.sort <= candidate.sort ? lowest : candidate,
      undefined,
    );
  if (!category) return [subsiteLink];

  return [
    subsiteLink,
    {
      title: category.name,
      to: `/${homePageUrl}?categories=${category.slug}&pq=`,
      qaId: 'breadcrumbs-mobile-category-link',
    },
  ];
}
